import { KForm, KPasswordCreateField } from "kinnect-general";

export default KForm.extend( {
	name: "KResetPasswordForm",

	props: {
		action: {
			...KForm.options.props.action,
			default: "auth/password/reset"
		},

		formTitle: {
			...KForm.options.props.formTitle,
			default: "Reset Password"
		},

		method: {
			...KForm.options.props.method,
			default: "post"
		},

		redirect: {
			...KForm.options.props.redirect,
			default: () => ( { name: "login" } )
		},

		successMessage: {
			...KForm.options.props.successMessage,
			default: "Your password has been updated. You can now use it to log in."
		},

		successTimeout: {
			...KForm.options.props.successTimeout,
			default: 10000
		}
	},

	data: vm => ( {
		formFields: {
			email: vm.$route.query.email,
			password: null,
			password_confirmation: null,
			token: vm.$route.query.token
		}
	} ),

	watch: {
		"formFields.password"( password ) {
			this.formFields.password_confirmation = password;
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				data: this.formFields
			}}
		>
			<KPasswordCreateField
				label="New Password*"
				required
				vModel={this.formFields.password}
				validationName="password"
				validationRules="required"
			></KPasswordCreateField>
		</KForm>;
	}
} );
